"use client";
import Image from "next/image";
import Link from "next/link";
import { scrollToAnchor } from "@/app/hooks/useScrollSmooth";
import Instagram from "./icons/instagram";
import WhatsApp from "./icons/whatsapp";
import Linkedin from "./icons/linkedin";
import { useResponsive } from "@/app/hooks/useResponsive";

const Footer = () => {
	const { isLg } = useResponsive()
  return (
    <footer className="bg-[hsl(var(--primary))] text-primary-foreground py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="lg:col-span-2 flex flex-col items-start gap-4">
            <Image
              className="h-auto w-auto cursor-pointer"
              src="/escapa/transp/escapa_1.png"
              alt="Logo da escapa"
              width={isLg ? 220 : 120}
              height={0}
              style={{ height: "auto" }}
              onClick={() => scrollToAnchor("top")}
            />
            <p className="text-white leading-relaxed md:max-w-[40ch]">
              Conectando luxo, turismo e tecnologia para criar experiências
              extraordinárias.
            </p>
          </div>

          <div className="text-white">
            <p className="font-semibold mb-4">Navegação</p>
            <ul className="space-y-2">
              {[
                "Voltar ao topo",
                "Ester",
                "Sua jornada",
                "Diferenciais",
                "Nossa história",
                "Serviços",
              ].map((item, i) => (
                <li key={i}>
                  <Link
                    key={i}
                    scroll={false}
                    href={`#${
                      i === 0
                        ? ""
                        : item
                            .replace(" ", "-")
                            .replace("ó", "o")
                            .replace("ç", "c")
                            .toLocaleLowerCase()
                    }`}
                    className="hover:text-gray-300 transition-colors duration-300"
                    onClick={() => {
                      scrollToAnchor(
                        i === 0
                          ? "top"
                          : item
                              .replace(" ", "-")
                              .replace("ó", "o")
                              .replace("ç", "c")
                              .toLocaleLowerCase()
                      );
                    }}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-white">
            <p className="font-semibold mb-4">Redes Sociais</p>
            <div className="flex gap-4">
              {[
                {
                  icon: Instagram,
                  label: "Instagram",
                  link: "https://www.instagram.com/escapa.ia/",
                },
                {
                  icon: WhatsApp,
                  label: "WhatsApp",
                  link: "https://wa.me/555181046948",
                },
                {
                  icon: Linkedin,
                  label: "LinkedIn",
                  link: "https://www.linkedin.com/company/escapa-ia/",
                },
              ].map((social, index) => {
                const Icon = social.icon;
                return (
                  <Link
                    key={index}
                    href={social.link}
                    className="w-10 h-10 bg-[hsl(var(--secondary))] rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300"
                    aria-label={social.label}
                    target="_blank"
                  >
                    <Icon className={index === 2 ? "w-5 h-5" : "w-6 h-6"} />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-500 pt-8 text-center">
          <p className="text-gray-300">
            © 2025 escapa! – Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
